import React, { createContext, useEffect, useState } from 'react'
import { ProductShop } from "app/ProductShop/ProductShop";
import { accessoryStorageGet, accessoryStorageSet, accessoryIsArrayDiff } from "app/React/Helpers/AccessoryStorageHelper";

const ProductShopWidgetContext = createContext({})

export function ProductShopWidget(props) {
  const [cartItems, setCartItems] = useState(accessoryStorageGet('cart-items') ?? [])

  useEffect(() => {
    const storageCartItems = accessoryStorageGet('cart-items') ?? []

    if (accessoryIsArrayDiff(cartItems, storageCartItems, 'id')) {
      accessoryStorageSet('cart-items', cartItems)
    }
  }, [cartItems, setCartItems])


  useEffect(() => {
    const storageListener = () => {
      setCartItems(accessoryStorageGet('cart-items') ?? [])
    }

    window.addEventListener('storage', storageListener, false)
    return () => {
      window.removeEventListener('storage', storageListener, false)
    }
  }, [])

  return (
    <ProductShopWidgetContext.Provider value={{
      cartItems,
      currentVariant: null,
      isAccessoryShop: true,
      order: {
        paymentType: 'cash'
      },
      setCartItems,
    }}>
      <ProductShop {...props} context={ProductShopWidgetContext} />
    </ProductShopWidgetContext.Provider>
  )
}
